export enum FunctionName {
  getTenantInfo = 'http-tenant-getInfo',
  listTenants = 'http-tenant-list',
  createTenant = 'http-tenant-create',
  updateTenant = 'http-tenant-update',
  addApiKey = 'http-tenant-apiKey',
  getModelRegistrationInfo = 'http-model-registrationInfo',
  getModelConsentFormInfo = 'http-model-consentInfo',
  confirmModelRegistration = 'http-model-registrationConfirm',
  saveModelRegistration = 'http-model-registrationSave',
  modelEmailInvite = 'http-model-emailInvite',
  resendEmail = 'http-model-resendEmail',
  revokeConsent = 'http-model-revokeConsent',
  generatePDF = 'http-model-generatePdf',
  addUser = 'http-user-add',
  deleteUser = 'http-user-delete',
  reinviteUser = 'http-user-reinvite',
  resetPassword = 'http-user-resetPassword',
  sendImagesToBynder = 'http-export-bynder',
  sendImagesToLytho = 'http-export-lytho',
  sendImagesToMediafiler = 'http-export-mediafiler',
  downloadZip = 'http-export-downloadZip',
  downloadMatches = 'http-export-downloadMatches',
  extendProject = 'http-project-extend',
  elasticSearch = 'http-elastic-search',
  faceAiTagAssets = 'http-faceAi-tagAssets',
  getSuggestions = 'http-faceAi-getSuggestions',
  deleteItems = 'http-delete-deleteItems',
  validateEmail = 'http-mail-validate',
  completeAddonSession = 'http-addon-completeSession',
  waitingRoomAction = 'http-asset-waitingRoomAction',
  assetShare = 'http-asset-share',
  assetShareView = 'http-asset-shareView',
  assetShareDownloadZip = 'http-asset-shareDownloadZip',
  assetCrop = 'http-asset-crop',
  assetLoadMonitoringResults = 'http-asset-loadMonitoringResults',
}
